var $a25c707e88b844a7$exports = {};
$a25c707e88b844a7$exports = {
  "decrease": function decrease(args) {
    return "\u05D4\u05E7\u05D8\u05DF ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "\u05D4\u05D2\u05D3\u05DC ".concat(args.fieldLabel);
  },
  "numberField": "\u05E9\u05D3\u05D4 \u05DE\u05E1\u05E4\u05E8"
};
export { $a25c707e88b844a7$exports as default };